import { couponActionTypes } from '../actions/types';

const initialState = {
  couponList: [],
  coupon: {},
  status: null,
};

export function coupon(state = initialState, action) {
  switch (action.type) {
    case couponActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case couponActionTypes.GET_ALL_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case couponActionTypes.GET_ALL_SUCCESS:
      console.log('--> action', action);
      return {
        ...state,
        status: 'success',
        couponList: action.coupons,
        error: null,
      };
    case couponActionTypes.GET_ALL_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case couponActionTypes.FIND_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case couponActionTypes.FIND_SUCCESS:
      return {
        ...state,
        status: 'success',
        coupon: action.coupon,
        error: null,
      };
    case couponActionTypes.FIND_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case couponActionTypes.CREATE_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case couponActionTypes.CREATE_SUCCESS:
      return {
        ...state,
        status: 'success',
        couponList: [action.coupon, ...state.couponList],
        error: null,
      };
    case couponActionTypes.CREATE_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case couponActionTypes.ADD_CODE_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case couponActionTypes.ADD_CODE_SUCCESS:
      const coupon = state.coupon;
      coupon.codes = action.codes
      return {
        ...state,
        status: 'success',
        coupon: coupon,
        error: null,
      };
    case couponActionTypes.ADD_CODE_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case couponActionTypes.UPDATE_CODE_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case couponActionTypes.UPDATE_CODE_SUCCESS:
      const updatecoupon = state.coupon;
      updatecoupon.codes = action.codes
      return {
        ...state,
        status: 'success',
        coupon: updatecoupon,
        error: null,
      };
    case couponActionTypes.UPDATE_CODE_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    default:
      return state;
  }
}
